"use client";

import { posthog } from "posthog-js";
import { track as vercelTrack } from "@vercel/analytics";
import { generateUUID } from "@drpcrd/utils/shared";

type Properties = Record<string, string | number | boolean | null>;

type ClientEventProps = {
  event: string;
  userId: string | null;
  properties?: Properties;
  options?: {
    excludeVercel?: boolean;
    excludePostHog?: boolean;
  };
};

export type TrackClientEventFunc<TrackProperties extends Properties> = ({
  userId,
  properties,
}: Pick<ClientEventProps, "userId"> & {
  properties?: TrackProperties;
}) => void;

export const trackClientEvent = ({
  event,
  userId,
  properties = {},
  options,
}: ClientEventProps) => {
  // PostHog tracking
  if (!options?.excludePostHog) {
    posthog.capture(event, {
      ...properties,
      distinctId: userId ?? `untracked_user_${generateUUID()}`,
    });
  }

  // Vercel Analytics tracking
  if (!options?.excludeVercel) {
    vercelTrack(event, { user_id: userId, ...properties });
  }

  // NOTE: We don't want to log to console in client-side for privacy reasons

  // ... add more analytics providers here as needed
};
